module.exports = __webpack_public_path__ + "img/VsShimmer2.cd502f75.jpg";